<template>
  <div class="">
    <div class="homes homes-x" style="padding: 15px 0 0 0">
      <div class="homes_info">
        <div class="homes_time">
          <h1 style="font-size: 24px; font-weight: 500"> {{ weatherData && weatherData.weather && weatherData.weather[0] ? $t(`weather.${weatherData.weather[0].main}`) : 'N/A' }},

            {{ typeof temperatureCelsius === 'string' ? temperatureCelsius.slice(0, 2) + ' °C' : 'N/A' }}</h1>
          <p class="nd_p_text120">{{ hours }}:{{ minutes }}</p>
          <MotivationList/>
        </div>
      </div>
      <HomeNodes style="height: 520px"/>
      <HomeTasksList style="height: 520px"/>
    </div>
  </div>

</template>
<script>
import HomeNodes from "@/components/main/HomeNodes.vue";
import HomeTasksList from "@/components/main/HomeTasksList.vue";
import axios from 'axios';
import MotivationList from "@/components/main/MotivationList.vue";

export default {
  name: 'HomesList',
  components: {MotivationList, HomeTasksList, HomeNodes},
  props: {
    color: {
      type: String,
      default: 'red'
    }
  },
  data() {
    return {
      hours: new Date().getHours(),
      minutes: new Date().getMinutes(),
      seconds: new Date().getSeconds(),
      weatherData: '',
      temperatureCelsius: 0,
      moteList: []
    }
  },
  created() {
    this.getWeather();
  },
  methods: {
    setTime() {
      setInterval(() => {
        const date = new Date()
        this.hours = date.getHours()
        this.minutes = this.checkSingleDigit(date.getMinutes())
        this.seconds = this.checkSingleDigit(date.getSeconds())
      }, 1000)
    },
    checkSingleDigit(digit) {
      return ('0' + digit).slice(-2)
    },
    getWeather() {
      const apiKey = '895284fb2d2c50a520ea537456963d9c'
      const input = 'Tashkent'
      const apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${input}&appid=${apiKey}`
      axios.get(apiUrl)
          .then(response => {
            this.weatherData = response.data;
            if (this.weatherData && this.weatherData.main && this.weatherData.main.temp) {
              this.temperatureCelsius = (this.weatherData.main.temp - 273.15).toFixed(2);
            } else {
              // Handle the case when the necessary properties are not available
            }
          })
          .catch(error => {
            return error
          });
    },
  },
  mounted() {
    // this.getWeather()
    this.setTime()
    if (
        this.weatherData &&
        this.weatherData.main &&
        this.weatherData.main.temp
    ) {
      this.temperatureCelsius = (this.weatherData.main.temp - 273.15).toFixed(2);
    } else {
      // Handle the case when the necessary properties are not available or temp is not a number
      // console.log('Missing or invalid data for temperature conversion');
    }
    // this.getMotivation()
  }
};


</script>

